<template>
  <div>
    <nav-top @showProfile="showProfile" />
    <div class="container-fluid">
      <div class="row flex-xl-nowrap">
        <!-- v-show keeps NavLeft mounted while a PDF preview borrows the full width. -->
        <div v-show="!previewOpen" :class="{ 'bd-banner-sidebar': isBannerEnabled }" class="col-12 col-md-3 col-xl-2 bd-sidebar">
          <nav-left />
          <div class="custom-version">
            <space class="small d-none d-md-block"> v{{ version }} </space>
            <space class="small d-none d-md-block">{{ userRole }}</space>
          </div>
        </div>
        <main :class="previewOpen ? 'col-12' : 'col-12 col-md-9 col-xl-10'" class="py-3 px-md-5 bd-content" role="main">
          <slot />
          <div class="custom-version">
            <hr />
            <pre class="small d-none d-md-block"> v{{ version }} </pre>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { authStore } from '@/stores/auth'
import { estimateStore } from '@/stores/estimate'
import NavTop from '@/layouts/navigation/NavTop.vue'
import NavLeft from '@/layouts/navigation/NavLeft.vue'

export default {
  name: 'LayoutSideNav',
  components: {
    NavTop,
    NavLeft
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(estimateStore, ['previewOpen']),
    version() {
      let _version = window.version ? window.version : ''
      return _version
    },
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    },
    userRole() {
      let _role = 'Admin'
      if (this.profile) {
        if (this.profile.roles) {
          if (this.profile.roles.length > 0) {
            switch (this.profile.roles[0]) {
              case 1:
              case 2:
              case 3:
              case 5:
              case 7:
              case 9:
              case 12:
              case 15:
                _role = 'Admin'
                break
              case 4:
              case 6:
              case 8:
              case 10:
              case 11:
              case 13:
              case 14:
              case 16:
              case 17:
                _role = 'User'
                break
            }
          }
        }
      }
      return _role
    }
  },
  methods: {
    showProfile() {
      this.$router.push({ name: 'profile' })
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-role {
  margin-left: 5px;
}
.custom-version {
  color: #fff;
  font-size: 0.8em;
}
</style>
